import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  educator_name: yup
    .string()
    .trim()
    .required('Educator Name field is required.'),
  school_club_name: yup
    .string()
    .trim()
    .required('School/Club Name field is required.'),
  school_club_address: yup.object().shape({
    address: yup.string().trim().required('Address field is required.'),
    city: yup.string().trim().required('City/Town field is required.'),
    state_province: yup
      .string()
      .trim()
      .required('State/Province field is required.'),
    postal_code: yup
      .string()
      .trim()
      .matches(
        /^[0-9]{5}(-[0-9]{4})?$/,
        'Zip/Postal Code must be a valid format.'
      )
      .required('Zip/Postal Code field is required.'),
  }),
  grade_level: yup
    .string()
    .trim()
    .required('Grade Level of Students field is required.'),
  email: yup.string().trim().email().required('Email field is required.'),
  phone: yup.string().trim().required('Please provide a valid phone number.'),
  activity_type: yup
    .string()
    .trim()
    .required(
      'Please select the activity you and your students are most interested in.'
    ),
  availability: yup
    .string()
    .required(
      'Please let us know the days/time-windows that would work best for a visit. Field is required.'
    ),
  additional_comments_: yup.string().trim(),
  opt_in: yup
    .boolean()
    .oneOf(
      [true],
      "Please check the box if you agree with Discovery Education's Privacy Policy and the Nielsen Foundation’s Privacy Policy."
    )
    .required(),
});
